import React, { Component } from 'react';
import './index.less';
import User from './User';
import MyFollowed from './myFollowed';
import HotRecommend from './hotRecommend';
export interface IABSHomeRightProps {
  login: boolean;
}

class ABSHomeRight extends Component<IABSHomeRightProps> {
  render() {
    const { login } = this.props;
    return (
      <div className="abs-home-right-content">
        { login ?
        <>
        <User isLogin={true} />
        <MyFollowed isLogin={true}/>
        </>
        :
        null
        }
        <HotRecommend />
      </div>
    );
  }
}

export default ABSHomeRight; 


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/abs/views/home/component/right/index.tsx